import dayjs from 'dayjs';
import ESPPPurchasePeriodType from './ESPPPurchasePeriodType';

function getNextPurchasePeriod(esppPurchasePeriods: ESPPPurchasePeriodType[], today: dayjs.Dayjs) {
  const nextPeriod = esppPurchasePeriods
    .filter((period) => period.enroll_date.isAfter(today))
    .sort((a, b) => {
      if (a.enroll_date.isSame(b.enroll_date)) {
        return a.purchase_date.diff(b.purchase_date);
      } else {
        return a.enroll_date.diff(b.enroll_date);
      }
    })[0];
  return nextPeriod;
}

export default getNextPurchasePeriod;